module.exports = require('./lib/index');



//////////////////
// WEBPACK FOOTER
// ./~/symbol-observable/index.js
// module id = ./node_modules/symbol-observable/index.js
// module chunks = 0